export default function reveal(node, opts = {}) {
  const { threshold = 0.2, once = true, direction = 'up', delay = 0 } = opts;
  const baseClass = direction === 'left' ? 'reveal-left' : direction === 'right' ? 'reveal-right' : 'reveal';
  node.classList.add(baseClass);
  let timer;
  const io = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      timer = setTimeout(() => node.classList.add('in'), delay);
      if (once) io.disconnect();
    }
  }, { threshold });
  io.observe(node);
  return {
    destroy() {
      clearTimeout(timer);
      io.disconnect();
    }
  };
}

